import React, { useEffect, useState,useRef } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import { HelmetProvider, Helmet } from "react-helmet-async";

import { SocketProvider } from "./context/SocketContext.js";
// import { loadStripe } from "@stripe/stripe-js";
import Cookies from "js-cookie";
import Chat from "./component/Contact/Chat.js";
import { IoIosChatbubbles } from "react-icons/io";
import HomePage from "./pages/HomePage";
import ContactPage from "./pages/ContactPage.jsx";
import BlogPage from "./pages/BlogPage.jsx";
import BlogDetailPage from "./pages/BlogDetailPage.jsx";
import LoyaltyProgramPage from "./pages/LoyaltyProgramPage.jsx";
import LocationPage from "./pages/LocationPage.jsx";
import OffersPage from "./pages/OffersPage.jsx";
import OrderPage from "./pages/OrderPage.jsx";
import MenuPage from "./pages/MenuPage.jsx";
import MyCartPage from "./pages/MyCartPage.jsx";
import DeliveryPage from "./pages/DeliveryPage.jsx";
import SummaryPage from "./pages/SummaryPage.jsx";
import SumarypageWithPayment from "./pages/SumarypageWithPayment.jsx";
import OfferDetailPage from "./pages/OfferDetailPage.jsx"
import OrderStatusPage from "./pages/OrderStatusPage.jsx";
import OrderStatusPageTwo from "./component/User/Order/OrderStatusPage.jsx";
import Dashboardpage from "./pages/Dashboardpage.jsx";
import ProfilePage from "./pages/ProfilePage.jsx";
import EditAccountPage from "./pages/EditAccountPage.jsx";
import WalletPage from "./pages/WalletPage.jsx";
import UserOrderPage from "./pages/UserOrderPage.jsx";
import UserLogsPage from "./pages/UserLogsPage.jsx";
import Login from "./Login.jsx"
import { store } from "./redux/store.js";
import { loadUser } from "./redux/User.js";
import { getAllProducts } from "./redux/action/product.js";
import ProtectedRoute from "./ProtectedRoute.jsx";
import "react-toastify/dist/ReactToastify.css"; // Required for styling
import UserOrderReceiptPage from "./pages/UserOrderReceiptPage.jsx"
import OfferPage from "./pages/OffersPage.jsx";
import { FaSpinner } from "react-icons/fa";
import { useSocket } from "./context/SocketContext.js";
import TermsAndConditions from "./pages/TermsAndConditions.jsx";
import PrivacyPolicy from "./pages/PrivacyPolicy.jsx";
// const stripePromise = loadStripe("your-publishable-key-here");
import api from "./utils/api.js";
import beepSound from './assets/notification.mp3'
import PasswordReset from "./PasswordReset.jsx"
import MicrosoftCalback from "./component/MicrosoftCalback.jsx";
import { receiveSupportMessageAction } from "./redux/action/chatActions.js";
import { ReceiveSupportMessage } from "./redux/chatSlice.js";
import LandingPageHome from "./pages/LandingPageHome.jsx";
const App = () => {
const [showChat, setShowChat] = useState(false);
const socket = useSocket();
const [data, setData] = useState({});
const [showIcon, setshowIcon] = useState(false);
  const RestaurantSavedId =  JSON.parse(localStorage.getItem('selectedRestaurantId'))
   const [locationData, setLocationData] = useState([]);
  const progressBarBgColor = '#07bc0c';
  const dispatch = useDispatch();

  const beepAudio = useRef(new Audio(beepSound));
  const { isAuthenticated, user, loading } = useSelector((state) => state.user);

  const getUnread = async()=> {
    try {
      const response =await api.get("/chat/getUnreadAlert")
      setData(response?.data)
      if(response?.data?.unread === true){
        setshowIcon(true)
      
      }else{
        setshowIcon(false)
      }
      console.log("-------------------------------",response?.data)
    } catch (error) {
      console.log(error)
    }
  }
  // useEffect(()=>{
  //   if(data?.unread === true){
  //     beepAudio.current.play().catch((error) => {
  //       console.error("Error playing beep sound:", error);
  //     });
  //   }
  // },[])
  const handleReadMessage = async()=>{
    console.log("read")
    try {
      const response = await api.patch("/chat/readMessages")
      console.log(response)
      // setshowIcon(false)
      getUnread()
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    const fetchData = async () => {
     
      try {
        // Simulating API call to fetch all data
        const response = await api.get(`/restaurant/${RestaurantSavedId}`);
        const results = response.data?.data || [];
        setLocationData(results); // Save full data
       
      } catch (error) {
        console.error("Error fetching restaurant data:", error);
      }
      
    };
    fetchData();
  }, [RestaurantSavedId]);
  useEffect(() => {
    // const interval = setInterval(() => {
    //   getUnread();
    // }, 3000);
  // if(showChat === true){
  //   handleReadMessage()
  // }
    if (!socket) return;
      // Listen for support messages
      socket.on("support:receive_message", (message) => {
        console.log("message from appp", message)
         dispatch(ReceiveSupportMessage(message));

        getUnread()
      });

      // Listen for conversation assignment
      socket.on("conversation_assigned", ({ conversationId, userId }) => {
        console.log("assigned", conversationId);
        getUnread()
      });
    
   
  }, [socket, dispatch,showChat]);
  const [init, setInit] = React.useState(false);
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when the page loads
  }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      dispatch(loadUser(userId)).finally(() => setInit(true));
    } else {
      setInit(true);
    }
    store.dispatch(getAllProducts());
  }, [dispatch]);
  // useEffect(()=> {
  //   if (showChat){
  //    handleReadMessage()
  //   }
  //  },[showChat])
  if (!init || loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
      </div>
    );
  }
  


  return (
    <>
    {loading?(
      <div className="flex justify-center items-center min-h-screen">
        <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
      </div>
):(
  <div 
  style={{
    backgroundImage: `url(${locationData?.bgImage?.[0]})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}>
    <HelmetProvider>
    <Helmet>
      <title>{locationData?.title || ''}</title>
   
      <link rel="icon" href={locationData?.logo && locationData?.logo[0]} />
    </Helmet>
    
  <BrowserRouter>
  <Routes>
  <Route path="/" element={<LandingPageHome />} />
  <Route path="/:id" element={<HomePage />} />
  <Route path="/login" element={<Login />} />

  <Route path="/contact" element={<ContactPage />} />
  <Route path="/blogs" element={<BlogPage />} />
  <Route path="/blog/:slug" element={<BlogDetailPage />} />
  <Route path="/locations" element={<LocationPage />} />
  <Route path="/offers" element={<OfferPage />} />
  <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
  <Route path="/privacy-policy" element={<PrivacyPolicy />} />

  <Route path="/offer/:offerId" element={<OfferDetailPage />} />
  {/* <Route path="/orders" element={<OrderPage />} /> */}
  <Route path="/menu" element={<MenuPage />} />
  <Route path="/my-cart" element={<MyCartPage />} />
  <Route
    path="/orders"
    element={
      // <Elements stripe={stripePromise}>
        <ProtectedRoute>
          <OrderPage />
        </ProtectedRoute>
      // </Elements>
    }
  />
    <Route
    path="/loyalty-program"
    element={
      // <Elements stripe={stripePromise}>
        <ProtectedRoute>
          <LoyaltyProgramPage />
        </ProtectedRoute>
      // </Elements>
    }
  />
    <Route
    path="/auth/outlook/callback"
    element={
      // <Elements stripe={stripePromise}>
      
          <MicrosoftCalback />
       
      // </Elements>
    }
  />
  <Route
    path="/delivery-page"
    element={
      // <Elements stripe={stripePromise}>
        <ProtectedRoute>
          <DeliveryPage />
        </ProtectedRoute>
      // </Elements>
    }
  />
      <Route
    path="/delivery"
    element={
      // <Elements stripe={stripePromise}>
        <ProtectedRoute>
          <SumarypageWithPayment />
        </ProtectedRoute>
      // </Elements>
    }
  />
    <Route
    path="/summary"
    element={
      <ProtectedRoute>
        <SummaryPage />
      </ProtectedRoute>
    }
  />


  <Route
    path="/order-status/:id"
    element={
      <ProtectedRoute>
        <OrderStatusPage />
      </ProtectedRoute>
    }
  />
  <Route
    path="/order-status-order/:id"
    element={
      <ProtectedRoute>
        <OrderStatusPageTwo />
      </ProtectedRoute>
    }
  />
  <Route
    path="/dashboard"
    element={
      <ProtectedRoute>
        <Dashboardpage />
      </ProtectedRoute>
    }
  />
  <Route
    path="/profile"
    element={
      <ProtectedRoute>
        <ProfilePage />
      </ProtectedRoute>
    }
  />
    <Route
    path="/user-reciept"
    element={
      <ProtectedRoute>
        <UserOrderReceiptPage />
      </ProtectedRoute>
    }
  />
  <Route
    path="/edit-account"
    element={
      <ProtectedRoute>
        <EditAccountPage />
      </ProtectedRoute>
    }
  />
  <Route
    path="/wallet"
    element={
      <ProtectedRoute>
        <WalletPage />
      </ProtectedRoute>
    }
  />
  <Route
    path="/your-orders"
    element={
      <ProtectedRoute>
        <UserOrderPage />
      </ProtectedRoute>
    }
  />
  <Route
    path="/user-logs"
    element={
      <ProtectedRoute>
        <UserLogsPage />
      </ProtectedRoute>
    }
  />
    <Route path="/reset-password" element={<PasswordReset />} />
</Routes>
<ToastContainer
  // position="bottom-center"
  autoClose={3000}
  progressStyle={{ background: progressBarBgColor }}
  style={{
    '--toastify-color-progress-success': '#AD343E',
  }}
/>
<div className="live-chat-icon">
      {/* Chat Toggle Button */}
    {/* {isAuthenticated && (
        <div className="fixed bottom-4 right-4">
        <button
          onClick={() =>{
            handleReadMessage()
           setShowChat(!showChat)}}
          className="relative bg-[#b91c1c] text-white rounded-full p-3 shadow-lg hover:bg-[#A65D20] focus:outline-none"
        >
          <IoIosChatbubbles className="text-3xl" />
          
 
          {showIcon && (
            <span className="absolute top-0 right-0 -mt-1  bg-green-600 text-green-600 text-xs w-4 h-4 flex items-center justify-center rounded-full">
              ●
            </span>
          )}
        </button>
      </div>
    )} */}

      {/* Chat Popup */}
      {/* {showChat && (
        <div
          className="fixed bottom-4 right-4 w-80 h-96 bg-white shadow-lg overflow-hidden z-50"
        >
         
          <div className=" h-full overflow-y-auto bg-[#fdf4e7]">
            <SocketProvider>
            <div className="flex items-center justify-between bg-[#b91c1c] text-white p-3 fixed w-80  mb-10">
            <span className="text-lg font-bold">Live Chat</span>
            <button
              onClick={() =>{
                handleReadMessage()
                setShowChat(false)}}
              className="text-white hover:text-gray-200 focus:outline-none"
            >
              ✕
            </button>
          </div>
              {isAuthenticated ? <Chat /> : <p className=" flex justify-center items-center">Please log in to chat.</p>}
            </SocketProvider>
          </div>
        </div>
      )} */}
    </div>
  </BrowserRouter>
  </HelmetProvider>
</div>
)}</>
  );
};

export default App;
